import { Disclosure } from "@headlessui/react"
import { ChevronDownIcon } from "@heroicons/react/solid"
import { CheckCircleIcon } from "@heroicons/react/outline"
import { ReactNode } from "react"
import WarningIcon from "./WarningIcon"

type AlertProps = {
  variant: "gray" | "red" | "blue" | "green" | "yellow"
  children: ReactNode,
  defaultOpen?: boolean
}

export default function Alert(props: AlertProps) {
  return (
    (function(): JSX.Element {
      switch (props.variant) {
        case "green":
          return <Disclosure defaultOpen={props.defaultOpen}>
            {({ open }) => (
              <>
                <DisclosureButtonWrapper className="tw-bg-emerald-200/40 tw-border-emerald-300 tw-text-green-900 dark:tw-text-green-400">
                  <DisclosureTitle
                    title="Success"
                    icon={<CheckCircleIcon />}
                    open={open} />

                  <Disclosure.Panel>
                    {props.children}
                  </Disclosure.Panel> 
                </DisclosureButtonWrapper>
              </>
            )}
          </Disclosure>
        case "blue":
          return <Disclosure defaultOpen={props.defaultOpen}>
            {({ open }) => (
              <>
                <DisclosureButtonWrapper className="tw-bg-blue-200/40 tw-border-blue-300 tw-text-blue-900 dark:tw-text-blue-400">
                  <DisclosureTitle
                    title="Heads Up"
                    icon={<CheckCircleIcon />}
                    open={open} />

                  <Disclosure.Panel>
                    {props.children}
                  </Disclosure.Panel> 
                </DisclosureButtonWrapper>
              </>
            )}
          </Disclosure>
        case "red":
          return <Disclosure defaultOpen={props.defaultOpen}>
            {({ open }) => (
              <>
                <DisclosureButtonWrapper className="tw-bg-red-200/40 tw-border-red-300 tw-text-red-900 dark:tw-text-red-400">
                  <DisclosureTitle
                    title="Warning"
                    icon={<WarningIcon />}
                    open={open} />

                  <Disclosure.Panel>
                    {props.children}
                  </Disclosure.Panel> 
                </DisclosureButtonWrapper>
              </>
            )}
          </Disclosure>
        case "yellow":
          return <Disclosure defaultOpen={props.defaultOpen}>
              {({ open }) => (
                <>
                  <DisclosureButtonWrapper className="tw-bg-yellow-200/40 tw-border-yellow-300 tw-text-yellow-900 dark:tw-text-yellow-400">
                    <DisclosureTitle
                      title="Warning"
                      icon={<WarningIcon />}
                      open={open} />

                    <Disclosure.Panel>
                      {props.children}
                    </Disclosure.Panel> 
                  </DisclosureButtonWrapper>
                </>
              )}
            </Disclosure>
          default: 
          return <div className="tw-bg-white tw-text-[#636464] tw-p-4 tw-rounded-md tw-flex tw-items-center">{props.children}</div>
      }
    })()
  )
}

function DisclosureButtonWrapper({ className, children } : { className: string, children: ReactNode }) {
  return <Disclosure.Button className={`tw-w-full tw-text-left tw-border tw-rounded-md tw-font-light tw-text-sm tw-mt-2 tw-px-4 tw-py-2 ${className}`}>
    {children}
  </Disclosure.Button>
}

type DisclosureTitleProps = {
  title: string,
  open: boolean,
  icon: ReactNode,
}

function DisclosureTitle({ title, open, icon }: DisclosureTitleProps) {
  return <div className="tw-font-bold tw-flex tw-justify-between">
    <div className="tw-flex tw-items-center tw-space-x-1">
      <span className="tw-h-5 tw-w-5 tw-inline-block">{icon}</span>
      <span>{title}</span>
    </div>
    <span className={`tw-h-5 tw-w-5 tw-inline-block ${open && "tw-rotate-180"}`}><ChevronDownIcon /></span> 
  </div>
}